import { render, staticRenderFns } from "./home.vue?vue&type=template&id=dd263c72&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd263c72')) {
      api.createRecord('dd263c72', component.options)
    } else {
      api.reload('dd263c72', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=dd263c72&", function () {
      api.rerender('dd263c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/home.vue"
export default component.exports